import { render, staticRenderFns } from "./bgremoval.vue?vue&type=template&id=e8684838&scoped=true"
import script from "./bgremoval.vue?vue&type=script&lang=js"
export * from "./bgremoval.vue?vue&type=script&lang=js"
import style0 from "./bgremoval.vue?vue&type=style&index=0&id=e8684838&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8684838",
  null
  
)

export default component.exports